export default __webpack_public_path__ + "static/media/bcbs-california-glyph.5a580fa3.png";